// extracted by mini-css-extract-plugin
export var slider = "Slider-module--slider--1LxrJ";
export var slick = "Slider-module--slick--8RCD6";
export var slickDots = "Slider-module--slickDots--vDWv-";
export var slideContainer = "Slider-module--slideContainer--2D0mT";
export var slideBackground = "Slider-module--slideBackground--1FQuM";
export var slide = "Slider-module--slide--2LLOT";